// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperImages-cls1___726189bc36d37d0873e{/*!*/}.PaperImages-cls2___4d782bc34fb07676df8{padding:16px 0;padding:var(--spacing-sx-16, 16px) 0;border-top:1px solid #141413;border-top:1px solid var(--stroke-dark, #141413)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperImages-cls1___726189bc36d37d0873e",
	"cls2": "PaperImages-cls2___4d782bc34fb07676df8 PaperImages-cls1___726189bc36d37d0873e"
};
export default ___CSS_LOADER_EXPORT___;
